import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::index
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:26
* @route '//org.launchstation.app/blog/posts'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/blog/posts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::index
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:26
* @route '//org.launchstation.app/blog/posts'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::index
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:26
* @route '//org.launchstation.app/blog/posts'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::index
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:26
* @route '//org.launchstation.app/blog/posts'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::index
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:26
* @route '//org.launchstation.app/blog/posts'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::index
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:26
* @route '//org.launchstation.app/blog/posts'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::index
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:26
* @route '//org.launchstation.app/blog/posts'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::create
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:36
* @route '//org.launchstation.app/blog/posts/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/blog/posts/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::create
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:36
* @route '//org.launchstation.app/blog/posts/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::create
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:36
* @route '//org.launchstation.app/blog/posts/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::create
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:36
* @route '//org.launchstation.app/blog/posts/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::create
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:36
* @route '//org.launchstation.app/blog/posts/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::create
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:36
* @route '//org.launchstation.app/blog/posts/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::create
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:36
* @route '//org.launchstation.app/blog/posts/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::store
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:60
* @route '//org.launchstation.app/blog/posts'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/blog/posts',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::store
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:60
* @route '//org.launchstation.app/blog/posts'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::store
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:60
* @route '//org.launchstation.app/blog/posts'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::store
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:60
* @route '//org.launchstation.app/blog/posts'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::store
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:60
* @route '//org.launchstation.app/blog/posts'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:43
* @route '//org.launchstation.app/blog/posts/{post}/edit'
*/
export const edit = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/blog/posts/{post}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:43
* @route '//org.launchstation.app/blog/posts/{post}/edit'
*/
edit.url = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { post: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { post: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            post: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        post: typeof args.post === 'object'
        ? args.post.id
        : args.post,
    }

    return edit.definition.url
            .replace('{post}', parsedArgs.post.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:43
* @route '//org.launchstation.app/blog/posts/{post}/edit'
*/
edit.get = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:43
* @route '//org.launchstation.app/blog/posts/{post}/edit'
*/
edit.head = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:43
* @route '//org.launchstation.app/blog/posts/{post}/edit'
*/
const editForm = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:43
* @route '//org.launchstation.app/blog/posts/{post}/edit'
*/
editForm.get = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:43
* @route '//org.launchstation.app/blog/posts/{post}/edit'
*/
editForm.head = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::update
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:78
* @route '//org.launchstation.app/blog/posts/{post}'
*/
export const update = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '//org.launchstation.app/blog/posts/{post}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::update
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:78
* @route '//org.launchstation.app/blog/posts/{post}'
*/
update.url = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { post: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { post: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            post: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        post: typeof args.post === 'object'
        ? args.post.id
        : args.post,
    }

    return update.definition.url
            .replace('{post}', parsedArgs.post.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::update
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:78
* @route '//org.launchstation.app/blog/posts/{post}'
*/
update.patch = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::update
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:78
* @route '//org.launchstation.app/blog/posts/{post}'
*/
const updateForm = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::update
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:78
* @route '//org.launchstation.app/blog/posts/{post}'
*/
updateForm.patch = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:127
* @route '//org.launchstation.app/blog/posts/{post}'
*/
export const destroy = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//org.launchstation.app/blog/posts/{post}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:127
* @route '//org.launchstation.app/blog/posts/{post}'
*/
destroy.url = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { post: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { post: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            post: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        post: typeof args.post === 'object'
        ? args.post.id
        : args.post,
    }

    return destroy.definition.url
            .replace('{post}', parsedArgs.post.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:127
* @route '//org.launchstation.app/blog/posts/{post}'
*/
destroy.delete = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:127
* @route '//org.launchstation.app/blog/posts/{post}'
*/
const destroyForm = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:127
* @route '//org.launchstation.app/blog/posts/{post}'
*/
destroyForm.delete = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::publish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:104
* @route '//org.launchstation.app/blog/posts/{post}/publish'
*/
export const publish = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: publish.url(args, options),
    method: 'post',
})

publish.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/blog/posts/{post}/publish',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::publish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:104
* @route '//org.launchstation.app/blog/posts/{post}/publish'
*/
publish.url = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { post: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { post: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            post: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        post: typeof args.post === 'object'
        ? args.post.id
        : args.post,
    }

    return publish.definition.url
            .replace('{post}', parsedArgs.post.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::publish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:104
* @route '//org.launchstation.app/blog/posts/{post}/publish'
*/
publish.post = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: publish.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::publish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:104
* @route '//org.launchstation.app/blog/posts/{post}/publish'
*/
const publishForm = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: publish.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::publish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:104
* @route '//org.launchstation.app/blog/posts/{post}/publish'
*/
publishForm.post = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: publish.url(args, options),
    method: 'post',
})

publish.form = publishForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::unpublish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:116
* @route '//org.launchstation.app/blog/posts/{post}/unpublish'
*/
export const unpublish = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unpublish.url(args, options),
    method: 'post',
})

unpublish.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/blog/posts/{post}/unpublish',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::unpublish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:116
* @route '//org.launchstation.app/blog/posts/{post}/unpublish'
*/
unpublish.url = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { post: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { post: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            post: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        post: typeof args.post === 'object'
        ? args.post.id
        : args.post,
    }

    return unpublish.definition.url
            .replace('{post}', parsedArgs.post.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::unpublish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:116
* @route '//org.launchstation.app/blog/posts/{post}/unpublish'
*/
unpublish.post = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unpublish.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::unpublish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:116
* @route '//org.launchstation.app/blog/posts/{post}/unpublish'
*/
const unpublishForm = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unpublish.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\PostController::unpublish
* @see app/Domain/Blog/Http/Controllers/Admin/PostController.php:116
* @route '//org.launchstation.app/blog/posts/{post}/unpublish'
*/
unpublishForm.post = (args: { post: string | { id: string } } | [post: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unpublish.url(args, options),
    method: 'post',
})

unpublish.form = unpublishForm

const posts = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    publish: Object.assign(publish, publish),
    unpublish: Object.assign(unpublish, unpublish),
}

export default posts